import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { AppVimeoGalleryPopupCloseIcon } from '@elfsight/icons';
import { getHandleActionKeyDown, useBreakpoints } from '@elfsight/widget-utils';
import classNames from 'classnames';
import { classnamePrefix, MOBILE_WIDTH_POPUP } from '../../../constants';
import { currentVideoContext } from '../currentVideoContext';
import { popupContext } from './PopupContext';
import { PopupItem } from './PopupItem';

export const Popup = ({ nextVideo }) => {
  const { toggleShowPopup, showPopup } = useContext(popupContext);
  const { currentVideo } = useContext(currentVideoContext);
  const [breakpoints, ref] = useBreakpoints(MOBILE_WIDTH_POPUP);

  const isMobile = breakpoints[MOBILE_WIDTH_POPUP];

  return (
    <Container
      onClick={() => {
        toggleShowPopup(false);
      }}
      tabIndex="0"
      onKeyDown={getHandleActionKeyDown(() => {
        toggleShowPopup(false);
      })}
      ref={ref}
      _isMobile={isMobile}
      _showPopup={showPopup}
      _currentVideo={currentVideo}
    >
      <Close>
        <AppVimeoGalleryPopupCloseIcon width="16" height="16" fill="#fff" />
      </Close>

      {currentVideo && showPopup && (
        <PopupItem popupItem={currentVideo} nextVideo={nextVideo} />
      )}
    </Container>
  );
};

const Container = styled.div.attrs(({ showPopup, currentVideo }) => ({
  className: classNames(`${classnamePrefix}-popup-container`, {
    [`${classnamePrefix}-popup-show`]: showPopup,
    [`${classnamePrefix}-popup-itemShow`]: currentVideo && showPopup
  })
}))`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
  box-sizing: border-box;
  padding: ${({ _isMobile }) => (_isMobile ? '0' : '0 20px')};

  ${({ _showPopup }) =>
    _showPopup &&
    css`
      opacity: 1;
      visibility: visible;
      pointer-events: all;
      z-index: 999999;
    `};
`;

const Close = styled.div.attrs({
  className: `${classnamePrefix}-popup-close`
})`
  position: absolute;
  top: 28px;
  right: 20px;
  opacity: 0.5;
  transition: opacity 0.3s ease;
  cursor: pointer;
  display: flex;

  &:hover {
    opacity: 1;
  }
`;
